import { render } from "./NavBar.vue?vue&type=template&id=33a8fdcf&scoped=true"
const script = {}

import "./NavBar.vue?vue&type=style&index=0&id=33a8fdcf&lang=scss&scoped=true"

import exportComponent from "C:\\fukunocha\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a8fdcf"]])

export default __exports__